<div class="section start">
    <div class="container">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    Live Tag Settings
                </ng-template>
                <div class="body-content"><live-tag-settings></live-tag-settings></div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Shifts
                </ng-template>
                <div class="body-content"><shifts></shifts></div>
            </mat-tab>
            <mat-tab *ngIf="isSuperAdmin">
                <ng-template mat-tab-label>
                    Client
                </ng-template>
                <div class="body-content"><app-clients></app-clients></div>
            </mat-tab>
            <mat-tab *ngIf="isSuperAdmin">
                <ng-template mat-tab-label>
                    Site
                </ng-template>
                <div class="body-content"><sites></sites></div>
            </mat-tab>
            <mat-tab *ngIf="isSuperAdmin || isUserClientAdmin || isUserSiteAdmin || isUserMultiClientAdmin">
                <ng-template mat-tab-label>
                    Devices
                </ng-template>
                <div class="body-content"><devices></devices></div>
            </mat-tab>
            <mat-tab *ngIf="isSuperAdmin || isUserClientAdmin || isUserSiteAdmin || isUserMultiClientAdmin">
                <ng-template mat-tab-label>
                    Users
                </ng-template>
                <div class="body-content"><users></users></div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Target Interval Settings (Device)
                </ng-template>
                <div class="body-content"><target-interval-settings  *ngIf="(device$ | async)" [model]="device$ | async" [saveFn]="saveDevice" [visibleDeviceDropDown]="visibleDeviceDropDown"></target-interval-settings></div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    Device Alerts
                </ng-template>
                <div class="body-content">
                    <mat-tab-group class="alert-tab-group">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Tolerance Alerts
                            </ng-template>
                            <div class="body-content"><device-alerts></device-alerts></div>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Off Spec Alerts
                            </ng-template>
                            <div class="body-content"><off-spec-alerts></off-spec-alerts></div>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Offline Alerts
                            </ng-template>
                            <div class="body-content"><device-offline-alert></device-offline-alert></div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
